import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class PreviousMeetingsWidgetPlaceholderStatisticProps extends BaseProps {}

export const PreviousMeetingsWidgetPlaceholderStatistic = (props: PreviousMeetingsWidgetPlaceholderStatisticProps) => {
  return (
    <div className={'previous-meetings-widget-placeholder-header-statistic-container'}>
      <div className={'previous-meetings-widget-placeholder-header-statistic-value'}/>
      <div className={'previous-meetings-widget-placeholder-header-statistic-label'}/>
    </div>
  );
}
